import { useEffect, useState } from "react";

const useTableSearch = (value: string) => {
  const text = value.trim();
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (text.length < 4) {
      setQuery("");
      return;
    }

    const timer = window.setTimeout(() => setQuery(text), 300);
    return () => window.clearTimeout(timer);
  }, [text]);

  return text.length >= 4 ? query : "";
};

export default useTableSearch;
